import React from 'react'
import PropTypes from 'prop-types'

import Slider from '@mui/material/Slider'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import theme from '../../theme'

const styles = {
    root: {
        width: '80%',
         color: theme.palette.primary.dark,
         colorPrimary: theme.palette.primary.dark,

    },
    slider: {
        width: "80%",
        //paddingRight:5
        //color: theme.palette.primary.dark
    },
    label: {
        paddingTop: 15,
        marginRight: 30,
    },
    button: {
        color: 'red',
    },
}

/**
 *
 * @param classes
 * @param from
 * @param to
 * @param steps
 * @param label
 * @param value
 * @param handleSliderChange
 * @param disabled
 * @returns {*}
 * @constructor
 */


/* const SEVSlider = withStyles({
    root: {
        color: theme.palette.primary.dark,
        //   height: 8
    },
    thumb: {
        //   height: 24,
        //   width: 24,
        backgroundColor: theme.palette.primary.dark,
        // border: '2px solid currentColor',
        //   marginTop: -8,
        //   marginLeft: -12,
        //   '&:focus, &:hover, &$active': {
        //     boxShadow: 'inherit',
        //   },
    },
    active: {},
    valueLabel: {
        //   left: 'calc(-50% + 4px)',
    },
    track: {
        // height: 8,
        // borderRadius: 4,
        //   color: 'inherit',
        // color: '#2d727f',
        backgroundColor: theme.palette.primary.dark,
    },
    rail: {
        // height: 8,
        // borderRadius: 4,
        //   color: 'inherit',
        // color: '#2d727f',
        backgroundColor: theme.palette.primary.dark,
    },
  })(Slider); */

  const SliderStyle={
    root: {
        color: theme.palette.primary.dark,
        //   height: 8
    },
    thumb: {
        //   height: 24,
        //   width: 24,
        backgroundColor: theme.palette.primary.dark,
        // border: '2px solid currentColor',
        //   marginTop: -8,
        //   marginLeft: -12,
        //   '&:focus, &:hover, &$active': {
        //     boxShadow: 'inherit',
        //   },
    },
    active: {},
    valueLabel: {
        //   left: 'calc(-50% + 4px)',
    },
    track: {
        // height: 8,
        // borderRadius: 4,
        //   color: 'inherit',
        // color: '#2d727f',
        backgroundColor: theme.palette.primary.dark,
    },
    rail: {
        // height: 8,
        // borderRadius: 4,
        //   color: 'inherit',
        // color: '#2d727f',
        backgroundColor: theme.palette.primary.dark,
    },
  }


const Sliders = ({ classes, from, to, steps, label, value, handleSliderChange, disabled }) => {
    const sliderLength = to - from
    const sliderLabelItems = []

    for (let i = 0; i <= sliderLength; i += 1) {
        if (i % steps === 0) {
            sliderLabelItems.push(
                {key:i, value:i, label:i}
            )
        }
    }


    const styles = {
        themed_slider:{
            "& .MuiSlider-thumb": {
                backgroundColor: theme.palette.primary.dark //color of thumbs
            },
            "& .Mui-active": {
                backgroundColor: theme.palette.primary.dark //color of thumbs
            }, 
            "& .MuiSlider-rail": {
                color: theme.palette.primary.dark 
            },
            "& .MuiSlider-track": {
                color: theme.palette.primary.dark 
            }, 
        },
        normal:{

        }
    }

    return (
        <div style={styles.root}>
            <Box width="100%" direction="column" justify="flex-start" container >
                <Box item sx={{marginTop:3}}>
                    <Typography style={styles.label}>{label}</Typography>
                </Box>
                <Box item style={{...styles.slider, width:"95%"}}>
                    <Slider
                        sx={disabled?styles.normal:styles.themed_slider}
                        disabled={disabled}
                        value={value}
                        min={from}
                        marks={sliderLabelItems}
                        max={to}
                        step={steps}
                        onChange={ (event, value) => handleSliderChange(value) }
                     
                    />
            
                </Box>
            </Box>
        </div>
    )
}

Sliders.defaultProps = {
    disabled: false,
}

Sliders.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    steps: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    handleSliderChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}
export default Sliders
